import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-user-check-icon]',
  template: `
    <svg:path
      d="M9.5 4C7.84315 4 6.5 5.34315 6.5 7C6.5 8.65685 7.84315 10 9.5 10C11.1569 10 12.5 8.65685 12.5 7C12.5 5.34315 11.1569 4 9.5 4ZM4.5 7C4.5 4.23858 6.73858 2 9.5 2C12.2614 2 14.5 4.23858 14.5 7C14.5 9.76142 12.2614 12 9.5 12C6.73858 12 4.5 9.76142 4.5 7ZM15.0731 2.91556C15.2803 2.40363 15.8633 2.15662 16.3752 2.36384C18.2058 3.10483 19.5 4.90008 19.5 7.00002C19.5 9.09996 18.2058 10.8952 16.3752 11.6362C15.8633 11.8434 15.2803 11.5964 15.0731 11.0845C14.8658 10.5725 15.1129 9.98955 15.6248 9.78232C16.7261 9.33654 17.5 8.25746 17.5 7.00002C17.5 5.74258 16.7261 4.6635 15.6248 4.21772C15.1129 4.01049 14.8658 3.4275 15.0731 2.91556ZM5 16C3.89543 16 3 16.8954 3 18V21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21V18C1 15.7909 2.79086 14 5 14H12C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16H5ZM21.2929 15.2929C21.6834 14.9024 22.3166 14.9024 22.7071 15.2929C23.0976 15.6834 23.0976 16.3166 22.7071 16.7071L18.7071 20.7071C18.3166 21.0976 17.6834 21.0976 17.2929 20.7071L15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929C15.6834 16.9024 16.3166 16.9024 16.7071 17.2929L18 18.5858L21.2929 15.2929Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCheckIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
